import { useState, useEffect } from 'react'
import Login from './components/Login'
import MainPage from './components/MainPage'
import type { User } from './utils/loginUtils'
import type { recipe } from './utils/recipeUtils'
import RecipeModeMainPage from './components/RrecipeMode/RecipeModeMainPage'

interface Mode {
  name: string
  recipe?: recipe
}

function App() {
  const [isMobile, setIsMobile] = useState(false)

  const [loggedInUser, setLoggedInUser] = useState<User | null>(() => {
    const savedUser = localStorage.getItem('loggedInUser')
    return savedUser ? JSON.parse(savedUser) : null
  })
  const [mode, setMode] = useState<Mode | null>(() => {
    const savedMode = localStorage.getItem('mode')
    return savedMode ? JSON.parse(savedMode) : null
  })

  useEffect(() => {
    const checkWidth = () => {
      setIsMobile(window.innerWidth <= 768)
    }
    checkWidth()
    window.addEventListener('resize', checkWidth)
    return () => window.removeEventListener('resize', checkWidth)
  }, [])

  useEffect(() => {
    localStorage.setItem('loggedInUser', JSON.stringify(loggedInUser))
  }, [loggedInUser])

  useEffect(() => {
    localStorage.setItem('mode', JSON.stringify(mode))
  }, [mode])

  if (!loggedInUser) {
    return <Login setLoggedInUser={setLoggedInUser} />
  }

  if (mode && mode.name === 'recipe' && mode.recipe) {
    return (
      <RecipeModeMainPage
        user={loggedInUser}
        recipe={mode.recipe}
        setMode={setMode}
        isMobile={isMobile}
      />
    )
  }
  return (
    <MainPage
      setLoggedInUser={setLoggedInUser}
      user={loggedInUser}
      setMode={setMode}
      isMobile={isMobile}
    />
  )
}

export default App

export type { Mode }
